<template>
  <div class="d-content">
    <div class="selectdiv">
      <div class="row">
        <div class="col-4">
          <div class="textContent">
            <p class="totolCount">{{ 33 }}</p>
            <strong class="totolReport">Total Reportee</strong>
          </div>
        </div>
        <div class="col-8">
          <div class="search-container float-right">
            <tl-search
              @change="filterData($event)"
              :placeholder="'Search Employee Name'"
            />
          </div>
        </div>
        <div class="lineTeam"></div>
      </div>
    </div>
    <div class="grid-list arranging">
      <div
        class="employeeModel"
        v-for="(item, index) in arrayOfTeam"
        :key="index"
        v-on:click="onSelectItem(item)"
      >
        <div>
          <div class="detailsOfReportee">
            <img
              :src="item.photo_url"
              class="userImg"
              alt=""
              v-if="item.photo_url"
            />
            <img
              src="@/assets/user.svg"
              class="userImg"
              alt=""
              v-if="!item.photo_url"
            />
            <span class="name"
              ><strong>{{ item.name }}</strong></span
            >
            <span class="designation"
              ><p>{{ item.designation }}</p></span
            >
            <span class="email"
              ><p>{{ item.email }}</p></span
            >
            <span class="eCode"
              ><p>E-code :{{ item.eCode }}</p></span
            >
            <span class="place"
              ><p>{{ item.place }}</p></span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal">
      <div class="modal custom-modal">
        <div class="modal-content modal-sm modal-border-radius">
          <div class="modal-emp-header">
            <img
              src="@/assets/close.png"
              class="close-img"
              v-on:click="showModal = false"
              alt=""
            />

            <div class="row">
              <div class="col-12 text-center">
                <img
                  src="@/assets/user.svg"
                  class="modal-user-img"
                  alt=""
                  v-if="!modalRecord.photo_url"
                /><img
                  :src="modalRecord.photo_url"
                  class="modal-user-img"
                  alt=""
                  v-if="modalRecord.photo_url"
                /><br />
                <span class="modal-emp-name"
                  >{{ modalRecord.name }} {{ modalRecord.last_name }}</span
                ><br />
                <span class="modal-emp-code"
                  >Employee Code:
                  <strong> {{ modalRecord.eCode }} </strong></span
                >
              </div>
            </div>
          </div>
          <div class="modal-body mx-2 my-2">
            <table>
              <tr>
                <td class="width-left-data">Designation :</td>
                <td class="width-right-data">
                  {{ modalRecord.designation }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Department :</td>
                <td class="width-right-data">
                  {{ modalRecord.department }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Job Location :</td>
                <td class="width-right-data">
                  {{ modalRecord.jobLocation }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Email :</td>
                <td class="width-right-data">
                  {{ modalRecord.email }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Reporting Manager :</td>
                <td class="width-right-data">
                  {{ modalRecord.reportingManager }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">DOJ :</td>
                <td class="width-right-data">
                  {{ modalRecord.date_of_joining }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact name :</td>
                <td class="width-right-data">
                  {{ modalRecord.emergency_contact_name }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact :</td>
                <td class="width-right-data">
                  {{ modalRecord.emergency_contact_number }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "myTeamMember",
  data() {
    return {
      arrayOfTeam: [
        {
          photo_url:
            "https://i.pinimg.com/736x/24/9f/6b/249f6bf52c6d01edbf971688c62b9b0a.jpg",
          name: "Pavan",
          designation: "Full Stack Developer",
          email: "pavan@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          photo_url:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3WEmfJCME77ZGymWrlJkXRv5bWg9QQmQEzw&usqp=CAU",
          name: "priya",
          designation: "Full Stack Developer",
          email: "priya@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          photo_url:
            "https://i.pinimg.com/736x/24/9f/6b/249f6bf52c6d01edbf971688c62b9b0a.jpg",
          name: "Arun",
          designation: "Full Stack Developer",
          email: "godArun@teamlease.com",
          eCode: "T46705",
          place: "Kailasa,Heaven",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          photo_url:
            "https://i.pinimg.com/originals/28/3a/b1/283ab1108ef8e379a2e555de019e1aee.jpg",
          name: "Manjunath",
          designation: "Full Stack Developer",
          email: "manjunath@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
        {
          name: "Sudeep",
          designation: "Full Stack Developer",
          email: "Sudeep@teamlease.com",
          eCode: "T46705",
          place: "Banglore,Karnataka",
        },
      ],
      showModal: false,
      modalRecord: null,
    };
  },
  methods: {
    onSelectItem(record) {
      this.modalRecord = record;
      this.showModal = true;
    },
  },
};
</script>
<style>
.textContent {
  display: flex;
  margin-top: 40px;
  margin-left: 30px;
}
.totolReport {
  margin-left: 30px;
  font-weight: bold;
  margin-top: 6px;
}
.totolCount {
  font-weight: 700;
  font-size: 25px;
  color: #34c0bd;
}
.search-container {
  margin-right: 18px;
  margin-top: 18px;
}
.lineTeam{
  width: 100%;
  height: 0.5px;
  margin: 10px 32px 10px 32px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}
img.userImg {
  width: 85px;
  height: 85px;
  border-radius: 50%;
}
.detailsOfReportee {
  display: inline-flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
}
.name {
  padding: 10px;
  font-size: bold;
}
.designation {
  font-size: 13px;
  color: #34c0bd;
  font-weight: bold;
  padding: 10px 50px 0px 50px;
  border-radius: 50px;
  border-width: 20%;
  background-color: white;
  margin-top: 4px;
}
.email {
  font-size: 16px;
  font-weight: 500;
  color: rgb(50, 159, 186);
  padding-top: 10px;
}
.eCode {
  font-size: 15px;
  font-weight: 500;
}
.employeeModel{
  height: 320px;
  width: 21%;
  border-radius: 10px;
  border: solid 1px #f2f2f2;
  display: inline-flex;
  background-color: #f7f7f7;
  align-items: center;
  justify-content: center;
  margin: 20px 20px 20px 20px;
}
.modal-user-img {
  width: 25%;
  margin-bottom: 10px;
  border-radius: 100%;
}

.modal-emp-name {
  width: 112px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-code {
  width: 146px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-header {
  background-color: #ebebeb;
  padding: 25px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-border-radius {
  border-radius: 8px;
}
img.close-img {
  float: right;
  cursor: pointer;
}
</style>
